export default {
    ORDER_PART(state, items) {
        state.items = items
    }
}
